import { labelModes, proxy } from '@/utils'

import render from './render'

export default {
  name: 'ClientIp',

  mixins: [ proxy() ],

  props: {
    labelMode: {
      type: String,
      default: labelModes.line
    },

    disabled: Boolean
  },

  render
}
